<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="400">
      <v-card flat>
        <v-toolbar dense color="pageHeader" dark height="35px">
          <span>{{ $t("hSelectTenant") }}</span>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  max-height="350"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="tenantSelect.name"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      required
                      :placeholder="$t('lblSelectTenant')"
                      clearables
                      @click:clear="clearSelection"
                    ></v-text-field>
                  </template>
                  <v-card flat>
                    <v-text-field
                      class="Neutral search-input ma-2"
                      color="neutralGray"
                      v-model.trim="searchCompanyName"
                      dense
                      filled
                      single-line
                      hide-details
                      :label="$t('lblCompanyName')"
                      @input="onSearch"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="20" class="mr-2" color="neutralGray"
                          >mdi-magnify</v-icon
                        >
                      </template>
                    </v-text-field>
                    <v-card-text
                      class="pa-0"
                      style="max-height: 200px; overflow: auto"
                    >
                      <v-treeview
                        v-model="selectedTenant"
                        :active.sync="selectedTenant"
                        dense
                        hoverable
                        activatable
                        :items="processedTreeItems"
                        item-key="id"
                        item-text="name"
                        item-children="tenants"
                        :return-object="false"
                        selection-type="independent"
                        class="tenant-list-item"
                        :search="searchCompanyName"
                        :open.sync="openNodeIds"
                      >
                        <template v-slot:prepend="{ item }">
                          <v-icon
                            v-if="item.isGroup"
                            size="20"
                            color="neutralGray"
                          >
                            mdi-folder</v-icon
                          >
                          <v-icon v-else size="20" color="neutralGray"
                            >mdi-domain</v-icon
                          >
                        </template>
                        <template v-slot:label="{ item }">
                          <div
                            :style="{ cursor: 'pointer' }"
                            @click.stop="!item.disabled && onTenantChange(item)"
                          >
                            {{ item.name }}
                          </div>
                        </template>
                      </v-treeview>
                    </v-card-text>
                    <v-list-item
                      v-if="processedTreeItems.length"
                      class="m-auto d-flex justify-center"
                    >
                      <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="3"
                        class="pa-1"
                      ></v-pagination>
                    </v-list-item>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-btn
                  :disabled="isCompanyNameExist"
                  color="info"
                  @click="onTenantSelect"
                >
                  Go
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { cloneDeep } from "lodash";
import {
  transformTenantGroupData,
  blankObjectConvertToArray,
} from "@/utils/util";
import userAuthService from "@/api/userAuthorizationService";
import { mapActions } from "vuex";

export default {
  name: "TenantDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = this.page * this.itemsPerPage;
      return this.tenantItems.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.tenantItems.length / this.itemsPerPage);
    },
    processedTreeItems() {
      return this.paginatedItems.map((group) => ({
        ...group,
        tenants: Array.isArray(group.tenants)
          ? group.tenants.map((tenant) => ({
              ...tenant,
            }))
          : [],
      }));
    },
    isCompanyNameExist() {
      return this.tenantSelect.id === "";
    },
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 5,
      valid: true,
      tenantSelect: { id: "", name: "" },
      tenantItems: [],
      menu: false,
      selectedTenant: [],
      openNodeIds: [],
      searchCompanyName: "",
      refTenantList: [],
    };
  },
  async mounted() {
    const tenants = this.$auth.user[process.env.VUE_APP_TENANT_KEY] || [];
    const tempTenant = await this.getTenantNamesHistory();
    const groups = blankObjectConvertToArray(
      this.$auth.user[process.env.VUE_APP_GROUP_KEY]
    );
   const newTenantList = addDisplayNames(tenants, tempTenant);
    const tenantGroupingList = {
      groups,
      tenants: newTenantList,
    };

    this.tenantItems = transformTenantGroupData(tenantGroupingList);
    this.refTenantList = cloneDeep(this.tenantItems);
  },
  watch: {
    processedTreeItems: {
      immediate: true,
      handler(newItems, oldItems) {
        this.selectedTenant = [];
        this.selectedTenant.push(this.tenantSelect.id);
      },
    },
    searchCompanyName(val) {
      if (val && val.trim() !== "") {
        this.openNodeIds = this.getAllGroupNodeIds(this.processedTreeItems);
      } else {
        this.openNodeIds = [];
      }
    },
  },
  methods: {
    ...mapActions({
      getTenantNamesHistory: "tenant/getTenantNamesHistory",
    }),
    onClose,
    onTenantSelect,
    onTenantChange,
    onSearch,
    clearSelection() {
      this.selectedTenant = [];
    },
    getAllGroupNodeIds(items) {
      let ids = [];
      items.forEach((item) => {
        if (item.tenants && item.tenants.length > 0) {
          ids.push(item.id);
        }
      });
      return ids;
    },
  },
};

function addDisplayNames(originalList, nameMappings) {
  const nameMap = new Map(nameMappings.map((item) => [item.id, item]));

  return originalList.map((item) => {
    let updatedName = item.name;

    if (
      nameMap.has(item.id) &&
      nameMap.get(item.id).tenantNamesHistory?.length > 0
    ) {
      const mappingItem = nameMap.get(item.id);
      updatedName = mappingItem.current_name;
    }
    return {
      ...item,
      name: updatedName,
    };
  });
}

function onSearch(value) {
  if (value !== "") {
    this.tenantItems = searchByName(this.refTenantList, value);
  } else {
    this.tenantItems = this.refTenantList;
  }
}

function searchByName(array, searchText) {
  const lowerSearch = searchText.toLowerCase();

  return array.filter((item) => {
    if (item.isGroup && Array.isArray(item.tenants)) {
      return (
        item.name.toLowerCase().includes(lowerSearch) ||
        item.tenants.some((tenant) =>
          tenant.name.toLowerCase().includes(lowerSearch)
        )
      );
    }
    return item.name.toLowerCase().includes(lowerSearch);
  });
}

async function onTenantChange(activeNodes) {
  this.tenantSelect = activeNodes;
  this.selectedTenant = [];
  this.selectedTenant.push(activeNodes.id);
  this.searchCompanyName = "";
  this.tenantItems = this.refTenantList;
  this.menu = false;
}

async function onTenantSelect() {
  if (this.$refs.form.validate()) {
    sessionStorage.setItem("tenantId", this.tenantSelect.id);
    localStorage.setItem("tenantId", this.tenantSelect.id);
    const currentTenant = "";
    const MAX_ATTEMPTS = 10;
    const RETRY_DELAY_MS = 50;

    const waitForTenantChange = async () => {
      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        if (currentTenant !== sessionStorage.getItem("tenantId")) {
          return true;
        }
        await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
      }
      return false;
    };

    if (await waitForTenantChange()) {
      await userAuthService.setActivityLog("login");
    }

    this.$emit("input", false);
    this.$emit("select");
    this.$router.go();
  }
}

function onClose() {
  this.$emit("input", false);
}
</script>

<style  scoped>
::v-deep
  .v-treeview.tenant-list-item
  .v-treeview-node--disabled
  > .v-treeview-node__root
  > .v-treeview-node__content {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>>